export { default } from "./useLazyAssignmentGet";
